<template>
  <div
    class="w-full bg-gray-200 h-4 relative overflow-hidden"
    :class="[{ 'rounded-full': rounded }, { indeterminate: indeterminate }]"
  >
    <div
      class="h-full progressbar"
      :class="[
        percentage < 50
          ? 'bg-red-300'
          : percentage >= 50 && percentage < 100
          ? 'bg-blue-300'
          : 'bg-green-300',
        { 'absolute top-0': indeterminate },
        { 'rounded-full': rounded },
      ]"
      role="progressbar"
      :style="{ width: `${percentage}%` }"
      :aria-valuenow="percentage"
      aria-valuemin="0"
      aria-valuemax="100"
    ></div>

    <span
      :class="[
        percentage < 50
          ? 'text-red-700'
          : percentage >= 50 && percentage < 100
          ? 'text-blue-700'
          : 'text-green-700',
        'absolute top-0 inset-x-1/2 font-semibold flex justify-center items-center h-full',
      ]"
    >
      {{ percentage }}%
    </span>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      default: "green",
    },
    percentage: {
      type: Number,
      default: 0,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    indeterminate: Boolean,
  },
};
</script>
<style scoped>
@keyframes progress-indeterminate {
  0% {
    width: 30%;
    left: -40%;
  }
  60% {
    left: 100%;
    width: 100%;
  }
  to {
    left: 100%;
    width: 0;
  }
}
.progressbar {
  transition: width 0.25s ease;
}
.indeterminate .progressbar {
  animation: progress-indeterminate 1.4s ease infinite;
}
</style>
